import React from 'react';
import CollapsibleTable from '.';

export const AssayData: React.FC < {} > = () => {
    return (
        <>
        <CollapsibleTable />
        </>
    );
}